import { defineComponent } from "vue";
import { PrivacyPolicyHtml, TermsOfUseHtml } from "@/constants/TermsAndPrivacy";
import BaseModal from "@/components/Shared/Modals/BaseModal/BaseModal.vue";
import { mapWritableState } from "pinia";
import { useRegisterTestStore } from "@/store/RegisterTestStore";

export default defineComponent({
  components: {
    BaseModal,
  },
  computed: {
    ...mapWritableState(useRegisterTestStore, ["patient"]),
  },
  data() {
    return {
      termsHtml: TermsOfUseHtml,
      privacyHtml: PrivacyPolicyHtml,
    };
  },
  methods: {
    toggleModal(status: boolean) {
      const el: any = this.$refs["base-modal"];
      el.toggleBaseModal(status);
    },
    acceptTerms() {
      this.patient.accept_terms = true;
      this.toggleModal(false);
    },
  },
});
